import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import "../index.css";
import { Link, useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIosNew';
import SentimentSatisfiedAltSharpIcon from '@mui/icons-material/SentimentSatisfiedAltSharp';
import { ProductContext } from "../context/AppContext";
import Footer from "./Common_Components/Footer";

function Feedback() {
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState('');
  const [feedbackImage, setFeedbackImage] = useState(null);
  const [fileName, setFileName] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [activePage, setActivePage] = useState("Profile");
  const { Translate } = useContext(ProductContext);
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log("Feedback Submitted:", feedback);
  //   navigate('/thank-you-feedback');
  // };
  const handleUploadClick = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.click();

    fileInput.onchange = (event) => {
      const file = event.target.files[0];
      if (file) {
        setFeedbackImage(file);
        setFileName(file.name);
        setImagePreview(URL.createObjectURL(file));
      }
    };
  };
  const authToken = localStorage.getItem("AuthToken");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!feedback) {
        alert('Please Enter Your Feedback Message');
        return;
      }

      const formData = new FormData();
      if (feedbackImage) {
        formData.append('image', feedbackImage, feedbackImage.name);
      }
      formData.append('feedback', JSON.stringify({ message: feedback }));
      const response = await fetch(
        'https://api.japaking.online/api/feedback',
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${authToken}`,
          },
          body: formData
        }
      );

      console.log('Feedback submitted:', response.data);
      navigate("/thank-you");

    } catch (err) {
      console.error('Error:', err);
      if (err.response && err.response.status === 401) {
        navigate("/login");
      }
    }
  };

  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  return (
    <div className='Profile_Design_Main_Div_11'>
      <div className='header_inner'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
              <h2>{Translate?.message?.data?.feedback || "Feedback"}</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>
      <div className="feedback-container">
        {/* User Experience Satisfaction Emoji */}
        <div className="emoji-section">
          <div className="emoji-box">
            <SentimentSatisfiedAltSharpIcon
              className="emoji-icon"
              style={{ fontSize: 40, color: 'white' }}  // Setting icon color to white
            />
          </div>
          <span className="emoji-text">{Translate?.message?.data?.userExperienceSatisfaction || "User Experience Satisfaction"}</span>
        </div>


        {/* Feedback Text Area */}
        <form className="feedback-form" onSubmit={handleSubmit}>
          <label htmlFor="feedback" className="feedback-label">{Translate?.message?.data?.feedback || "Feedback"}*</label>
          <textarea
            id="feedback"
            className="feedback-textarea"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          />
          <label htmlFor="upload-image" className="upload-label-feedback">{Translate?.message?.data?.attachImage || "Attach Image"}</label>
          <div className="upload-section">
            <button type="button" className="upload-button-feedback" onClick={handleUploadClick}>{Translate?.message?.data?.uploadImage || "Upload Image"}</button>
            {fileName && (
              <>
                <span className="file-name">{fileName}</span>
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="image-preview"
                    style={{ width: '100px', height: '100px', marginLeft: '10px', borderRadius: '8px' }}
                  />
                )}
              </>
            )}

          </div>
          <button type="submit" className="submit-button-feeback">{Translate?.message?.data?.submit || "Submit"}</button>
        </form>

        {/* Footer with Navigation Icons */}
        {/* Footer Section */}
        <Footer />
      </div>
    </div>
  );
}

export default Feedback;
